import { AlertTriangle, Calendar } from "lucide-react";

interface WeekendIndicatorProps {
  date: string;
  className?: string;
}

export const WeekendIndicator = ({ date, className = "" }: WeekendIndicatorProps) => {
  if (!date) return null;

  // فحص إذا كان اليوم جمعة أو سبت
  const checkDate = new Date(date);
  const dayOfWeek = checkDate.getDay();
  const isWeekend = dayOfWeek === 5 || dayOfWeek === 6; // 5 = جمعة، 6 = سبت

  if (!isWeekend) return null;

  const getWeekdayName = (dateString: string) => {
    const date = new Date(dateString);
    const days = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
    return days[date.getDay()];
  };

  const weekday = getWeekdayName(date);

  return (
    <div className={`flex items-center gap-2 p-3 bg-orange-50 border border-orange-200 rounded-lg text-orange-700 text-sm ${className}`}>
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />
      <div className="flex items-center gap-1">
        <Calendar className="h-4 w-4" />
        <span className="font-medium">يوم {weekday} - يوم إجازة</span>
      </div>
    </div>
  );
};